module.exports = __webpack_public_path__ + "img/penguin.7ede2a1c.svg";